import { snakeToTitleCase } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Status from 'components/shared/Status/Status';

const batteryColor = (percentage) => {
  if (percentage >= 60) return 'success';
  if (percentage >= 25) return 'warning';
  return 'danger';
};

const Card = ({ label, children }) => (
  <div className="flex min-w-0 flex-1 flex-col gap-1 rounded-md border border-solid border-neutral-200 bg-white px-3 py-2">
    <span className="text-xs text-neutral-600">{label}</span>
    <div className="flex min-w-0 items-center gap-2">{children}</div>
  </div>
);

const SummaryRow = ({ device }) => {
  const percentage = Number(device.batteryPercentage);
  const hasPercentage = Number.isFinite(percentage);
  const batteryTone = hasPercentage ? batteryColor(percentage) : 'neutral';

  return (
    <div className="flex flex-wrap gap-2">
      <Card label="Battery">
        <Icon
          icon={device.isCharging ? 'electronics-state-mono' : 'electronics-state-linear'}
          size={16}
          color={batteryTone}
        />
        <span className="truncate text-sm font-500 text-neutral-900">
          {hasPercentage ? `${percentage}%` : '—'}
          {device.batteryLevel ? (
            <span className="ml-1 text-xs text-neutral-500">({device.batteryLevel}V)</span>
          ) : null}
        </span>
        {device.isCharging ? <Status status="Charging" color="success" size="small" /> : null}
      </Card>

      <Card label="USB connection">
        <Status
          status={device.isUsbConnected ? 'Connected' : 'Disconnected'}
          color={device.isUsbConnected ? 'success' : 'neutral'}
          size="small"
        />
        {/* {device.connectionType ? (
          <span className="truncate text-xs text-neutral-500">
            via {snakeToTitleCase(String(device.connectionType))}
          </span>
        ) : null} */}
      </Card>

      <Card label="Terminal state">
        <Status
          status={
            device.terminalCategory ? snakeToTitleCase(String(device.terminalCategory)) : 'Unknown'
          }
          color={device.terminalCategory ? 'primary' : 'neutral'}
          size="small"
        />
      </Card>
    </div>
  );
};

export default SummaryRow;
